import { produce } from 'immer';
import parseUrl from 'url-parse';
/**
 * Transforms `a` (anchor) tag by checking validity of the `href` attribute, and
 * if valid perform additional mods required for external links.
 *
 * @param tagName The name of the tag.
 * @param attributes The tag attributes.
 */
export const transformTagA = (tagName, attributes) => {
    try {
        const source = attributes.href.startsWith('www')
            ? `https://${attributes.href}`
            : attributes.href;
        const { href, host } = parseUrl(source);
        const tag = {
            tagName,
            attribs: Object.assign(Object.assign({}, attributes), { href }),
        };
        return produce(tag, (draft) => {
            if (host && host !== window.parent.location.host) {
                draft.attribs.target = '_blank';
                draft.attribs.rel = 'noopener noreferrer nofollow';
            }
        });
    }
    catch (_a) {
        // Strip the tag entirely if href is invalid.
        return { tagName: '', attribs: {} };
    }
};
